'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const executeOrResolveDefault = (callback, config) => {
    const { execute, defaultValue } = config;
    if (execute) {
        return callback();
    }
    return Promise.resolve(defaultValue);
};

exports.executeOrResolveDefault = executeOrResolveDefault;
//# sourceMappingURL=execute-or-resolve-default.js.map
